import { useMemo } from 'react';
import { RootSettings, UIStartupDto } from '../api/generated/data-contracts';
import { useUISettings } from '../context/network/http/QueryProvider/queries/UISettings';

export type Checker = (settings: RootSettings, allSettings: UIStartupDto) => boolean;
export const useCheckFeatureFlag = (checker: Checker) => {
	const { data: uiSetting } = useUISettings();
	return useMemo(() => checker(uiSetting.settings, uiSetting), [checker, uiSetting]);
};
